import React from 'react';

export const Homepage = React.lazy(() => import('../components/Sections/Main'));
export const TERMS_CONDITIONS = React.lazy(() => import('../components/Pages/Termsconditions'));
export const PRIVACY_POLICY = React.lazy(() => import('../components/Pages/PrivacyPolicy'));